import * as React from 'react';
import classnames from 'classnames';
import { useTheme } from '@emotion/react';
import { ArrowDownIcon } from '../Icons/ArrowDownIcon';
import { useState } from 'react';

interface IAccordionProps {
    items: { title: string; content: React.ReactNode }[];
    allowMoreThanOneOpen?: boolean;
    firstTabOpenByDefault?: boolean;
    onHeaderClick?: () => void;
    allowActiveItem?: boolean;
    customAccordion?: {
        accordionItem?: string;
        accordionHeader?: string;
        accordionActive?: string;
        accordionContent?: string;
        accordionContentOpen?: string;
        accordionToggle?: string;
        accordionToggleIcon?: string;
    };
}

const Accordion = ({
    items,
    allowMoreThanOneOpen,
    firstTabOpenByDefault = false,
    onHeaderClick = null,
    allowActiveItem = false,
    customAccordion = {
        accordionItem: 'accordion__item',
        accordionHeader: 'accordion__item__header',
        accordionActive: '',
        accordionContent: 'accordion__item__content',
        accordionContentOpen: 'accordion__item__content--open',
        accordionToggle: '',
        accordionToggleIcon: '',
    },
}: IAccordionProps) => {
    const [state, setState] = useState(
        items.map((el, index) => {
            if (index === 0 && firstTabOpenByDefault) {
                return { ...el, isOpen: true, isLoaded: true };
            }
            return { ...el, isOpen: false, isLoaded: false };
        }),
    );
    const theme = useTheme();

    const toggleOpenTab = (index) => {
        if (state[index].isOpen) {
            state[index].isOpen = false;
        } else {
            if (!allowMoreThanOneOpen) {
                state.forEach((el) => {
                    el.isOpen = false;
                });
            }
            state[index].isOpen = true;
            state[index].isLoaded = true;

            if (onHeaderClick) {
                onHeaderClick();
            }
        }
        setState([...state]);
    };

    return (
        <>
            {state.map((el, index) => (
                <div key={el.title} className={customAccordion.accordionItem}>
                    <div
                        className={classnames(customAccordion.accordionHeader, {
                            accordion__item__active: allowActiveItem && el.isOpen,
                            [customAccordion.accordionActive]: allowActiveItem && el.isOpen,
                        })}
                        onClick={() => toggleOpenTab(index)}
                    >
                        {el.title}
                        <button
                            data-testid="accordion-item-toggle"
                            className={classnames('accordion__toggle', {
                                'accordion__toggle--reverse': el.isOpen,
                                [customAccordion?.accordionToggle]: true,
                            })}
                            style={{ background: theme.icon.brandColor1 }}
                        >
                            <ArrowDownIcon
                                className={`accordion__toggle__icon ${customAccordion?.accordionToggleIcon}`}
                            />
                        </button>
                    </div>
                    <div
                        data-testid="accordion-item-content"
                        className={classnames(customAccordion.accordionContent, {
                            [customAccordion.accordionContentOpen]: el.isOpen,
                        })}
                    >
                        {el.isLoaded && el.content}
                    </div>
                </div>
            ))}
        </>
    );
};

export default Accordion;
